"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateChildCareExpenseData = exports.childCareExpenseFormRules = exports.childCareExpenseSchema = void 0;
const converters_1 = require("../../converters");
const expense_1 = require("./expense");
exports.childCareExpenseSchema = {
    fields: {
        ...expense_1.expenseSchema.fields,
    },
    messages: {
        ...expense_1.expenseSchema.messages,
        institution_name: {
            maxLength: 'Child Care Provider Name must be 50 characters or less',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.childCareExpenseFormRules = (0, converters_1.toReactHookForm)(exports.childCareExpenseSchema, expense_1.expenseFieldMapping);
exports.validateChildCareExpenseData = (0, converters_1.createValidator)(exports.childCareExpenseSchema);
